import { deleteRequestWrapper } from "../../utilities";

export type deleteEnvironmentResponse = { success: boolean };

export function deleteEnvironment(
  id: string,
  authId: string
): Promise<deleteEnvironmentResponse> {
  return deleteRequestWrapper<never, deleteEnvironmentResponse>({
    url: `${ENV_SETTINGS.API_URL}/environment/${id}`,
    idToken: authId,
  });
}
